import { render, staticRenderFns } from "./ListBusinessServices.vue?vue&type=template&id=45660f45&lang=pug&"
import script from "./ListBusinessServices.vue?vue&type=script&lang=js&"
export * from "./ListBusinessServices.vue?vue&type=script&lang=js&"
import style0 from "./ListBusinessServices.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports